import { useIntl } from 'react-intl';
import Content from 'src/componentes/pages/content';
import List from 'src/componentes/list';
import ListColumn from 'src/componentes/list/list-column';
import { COLUNAS, FILTROS } from 'src/utils/constants';
import useAuth from 'src/hooks/useAuth';
import SearchSchema from './SearchSchema';
import Search from './search';
import { capitalizeFirstLetter } from 'src/utils/string';
import Avatar from 'src/componentes/avatar';

const ColaboradorLookupList = ({
  showContent = true,
  showConfirmButton = true,
  customListUrl,
  fillAvailableHeight = false,
  ...props
}) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  const renderNome = (item) => {
    return (
      <Avatar
        foto={item.fotoArquivo}
        label={item.nome}
        size={28}
        colaboradorId={item.id}
        showLabel={true}
      />
    );
  };

  const adjustFilterOnRemoveChip = (field, currentFilter, previousFilter) => {
    const adjustedFilter = props.adjustFilterOnRemoveChip
      ? props.adjustFilterOnRemoveChip(field, currentFilter, previousFilter)
      : currentFilter;

    if (field !== 'area') return adjustedFilter;

    return {
      ...adjustedFilter,
      areasSubordinadas: false,
    };
  };

  const list = (
    <List
      {...props}
      url="/Colaborador"
      customListUrl={customListUrl}
      customAction="ObterListaColaboradoresLookup"
      showExport={false}
      showNew={false}
      showMenu={false}
      showSearch={true}
      showFilter={true}
      searchSchema={SearchSchema}
      searchComponent={<Search />}
      filtroId={FILTROS.COLABORADOR_LOOKUP}
      tag={COLUNAS.COLABORADOR_LOOKUP}
      filterDrawer
      showConfirmButton={showConfirmButton}
      fillAvailableHeight={fillAvailableHeight}
      adjustFilterOnRemoveChip={adjustFilterOnRemoveChip}
    >
      <ListColumn
        headerText={intl.formatMessage({ id: 'nome' })}
        valueField="nome"
        valueFunction={renderNome}
        sortField="nome"
        required
        default
      />
      <ListColumn
        headerText={intl.formatMessage({ id: 'matricula' })}
        valueField="idIntegracao"
        sortField="idIntegracao"
        default
      />
      <ListColumn
        headerText={capitalizeFirstLetter(resources.area)}
        valueField="unidadeArea"
        sortField="organizacao.nome"
        default
      />
    </List>
  );

  if (!showContent && fillAvailableHeight) {
    return (
      <div
        style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          minHeight: 0,
        }}
      >
        {list}
      </div>
    );
  }

  if (!showContent) return list;

  return (
    <Content
      showBackButton={false}
      titulo={capitalizeFirstLetter(resources.colaboradores)}
    >
      {list}
    </Content>
  );
};

export default ColaboradorLookupList;
